module.exports = __webpack_public_path__ + "img/productService.d2f998ed.jpg";